module.exports = __webpack_public_path__ + "static/media/other.1da7df18.jpg";